/**
 * @generated SignedSource<<f00b9f34f084af0c44ccdaffeaab4d03>>
 * @relayHash 28e8cbdbeb4f550a7172ffd1c0454bc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 449d1a019e85e848bdc90eac809042aa3d0d56c5805c730187e929a3304c7bba

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcHelpCenterVirtualAgentSettingsQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  isHideKbColumnEnabled: boolean;
  isJsmAIConfigEnabled: boolean;
  isTotalArticleCountEnabled: boolean;
};
export type srcHelpCenterVirtualAgentSettingsQuery$data = {
  readonly helpCenter?: {
    readonly helpCenterById: {
      readonly __typename: string;
      readonly message?: string | null;
      readonly virtualAgentEnabled?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"settingsBreadcrumbsFragment" | "settingsVirtualAgentSettingsTabFragment">;
    } | null;
  } | null;
  readonly helpObjectStore_searchArticles?: {
    readonly " $fragmentSpreads": FragmentRefs<"settingsVirtualAgentLinkedArticlesFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"settingsVirtualAgentSettingsTabMappedProjectsFragment">;
};
export type srcHelpCenterVirtualAgentSettingsQuery = {
  response: srcHelpCenterVirtualAgentSettingsQuery$data;
  variables: srcHelpCenterVirtualAgentSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHideKbColumnEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmAIConfigEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTotalArticleCountEnabled"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "virtualAgentEnabled"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v12 = [
  (v5/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v13 = [
  (v5/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "helpCenterARI",
        "variableName": "helpCenterAri"
      },
      {
        "kind": "Literal",
        "name": "helpCenterId",
        "value": ""
      },
      {
        "kind": "Literal",
        "name": "helpCenterMappingStatus",
        "value": "LINKED"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "selections": [
      {
        "condition": "isJsmAIConfigEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "HelpCenterQueryApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "settingsVirtualAgentSettingsTabFragment"
                      },
                      (v10/*: any*/)
                    ],
                    "type": "HelpCenter"
                  },
                  (v11/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "settingsBreadcrumbsFragment"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isTotalArticleCountEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "helpObjectStore_searchArticles",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "settingsVirtualAgentLinkedArticlesFragment"
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "isHideKbColumnEnabled",
            "variableName": "isHideKbColumnEnabled"
          }
        ],
        "kind": "FragmentSpread",
        "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "jiraProjectsMappedToHelpCenter",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "small"
                          }
                        ]
                      },
                      {
                        "condition": "isHideKbColumnEnabled",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "args": (v6/*: any*/),
                            "kind": "LinkedField",
                            "name": "knowledgeBaseArticlesCount",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "count"
                                  }
                                ],
                                "type": "KnowledgeBaseArticleCountSource"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "virtualAgentConfiguration",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isAiResponsesEnabled"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "liveIntentsCount"
                              }
                            ],
                            "type": "VirtualAgentConfiguration"
                          },
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v15/*: any*/),
                            "type": "VirtualAgentQueryError"
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v13/*: any*/),
            "filters": [
              "cloudId",
              "filter"
            ],
            "handle": "connection",
            "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
            "kind": "LinkedHandle",
            "name": "jiraProjectsMappedToHelpCenter"
          }
        ]
      },
      {
        "condition": "isJsmAIConfigEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "HelpCenterQueryApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "concreteType": "HelpCenterName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "default"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "slug"
                      }
                    ],
                    "type": "HelpCenter"
                  },
                  (v11/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isTotalArticleCountEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "helpObjectStore_searchArticles",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  }
                ],
                "type": "HelpObjectStoreArticleSearchResults"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "449d1a019e85e848bdc90eac809042aa3d0d56c5805c730187e929a3304c7bba",
    "metadata": {},
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "336c89be85723469b9110ef6c88dd241";

export default node;
